import React, { useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";

export const EmployeeMenuItems = [
  {
    header: "تنظیمات",
    headerIcon: SettingsIcon,
    items: [
      {
        name: "تنظیمات نمایش",
        route: "/setting-set-parameter",
        isActive: "parameter",
      },
    ],
  },
  {
    header: "سفارش‌ها",
    headerIcon: ShoppingBasketIcon,
    items: [
      {
        name: "ثبت سفارش",
        route: "/create-order",
        isActive: "create-order",
      },
      {
        name: "سفارش‌های ثبت شده",
        route: "/new-orders",
        isActive: "new-orders",
      },
    ],
  },
  {
    header: "پیام رسان",
    headerIcon: EmailIcon,
    items: [],
    route: "/messages",
  },
  {
    header: "گفتگوها",
    headerIcon: TelegramIcon,
    items: [],
    route: "/chats",
    haveBadge: true,
  },
];
